<template>
  <v-container class="py-6">
    <v-row>
      <v-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2">
        <h3 class="text-h5 font-weight-bold mb-6">
          Featured in these galleries
        </h3>
        <v-row>
          <template v-if="loading">
            <v-col v-for="item in 3" :key="`sk_${item}`" cols="12" sm="6">
              <v-skeleton-loader
                id="sk-loader"
                height="330"
                type="image, card-heading"
              ></v-skeleton-loader>
            </v-col>
          </template>
          <template v-else>
            <v-col
              v-for="(gallery, index) in filteredGalleries"
              :key="index"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="0">
                <nuxt-link
                  :to="`/galleries/${gallery.id}?from=photo&id=${photo.id}`"
                  class="no-underline"
                >
                  <v-img
                    :src="gallery.thumbnail"
                    :alt="`${gallery.title} Gallery`"
                    :height="getThumbHeight"
                    cover
                  >
                    <template #placeholder>
                      <v-row
                        class="primary fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="tertiary"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </nuxt-link>
                <v-card-text class="card-text">
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <nuxt-link
                        :to="
                          `/galleries/${gallery.id}?from=photo&id=${photo.id}`
                        "
                        class="no-underline text-truncate"
                      >
                        <h3 class="text-body-1 font-weight-bold">
                          {{ gallery.title }}
                        </h3>
                      </nuxt-link>
                    </div>
                  </div>
                  <h4 class="text-body-2 my-1 d-flex align-center">
                    <v-avatar size="24" class="mr-2">
                      <img
                        :src="gallery.ownerAvatar"
                        :alt="`${gallery.ownerFullName} avatar.`"
                      />
                    </v-avatar>
                    <span class="mr-2 text-nowrap">by</span>
                    <nuxt-link
                      :to="
                        `/photographer/${gallery.ownerUserName ||
                          gallery.userId}`
                      "
                      class="no-underline font-weight-bold text-truncate"
                    >
                      {{ gallery.ownerFullName }}
                    </nuxt-link>
                  </h4>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
          <v-col v-if="galleries.length > 3" cols="12" class="text-right">
            <v-btn depressed small dark @click="openFeaturedGalleriesDialog">
              View all
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Featured-galleries-dialog :photo="photo" />
  </v-container>
</template>

<script>
export default {
  name: 'PhotoFeaturedGalleries',
  components: {
    FeaturedGalleriesDialog: () => import('@/components/photo/FeaturedGalleriesDialog.vue')
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    photo: {
      type: Object,
      default: () => {}
    },
    galleries: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getThumbHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
          return 180
        case 'md':
          return 150
        case 'xs':
        case 'lg':
        case 'xl':
        default:
          return 220
      }
    },
    filteredGalleries() {
      const galleryStore = this.galleries
      const bpName = this.$vuetify.breakpoint.name
      if (bpName === 'xs' || bpName === 'sm') {
        return galleryStore.slice(0, 2)
      } else {
        return galleryStore.slice(0, 3)
      }
    }
  },
  methods: {
    openFeaturedGalleriesDialog() {
      this.$store.dispatch('photos/featuredInGalleriesDialogVisible', true)
    }
  }
}
</script>

<style scoped>
.card-text {
  border: thin solid rgba(0, 0, 0, 0.12);
  border-top: none;
  height: 80px;
}
::v-deep .v-skeleton-loader__image {
  height: 250px !important;
}
::v-deep .v-skeleton-loader__card-heading {
  border: thin solid rgba(0, 0, 0, 0.12);
  border-radius: 0 0 4px 4px !important;
  border-top: none;
  height: 80px;
}
</style>
